import { render, staticRenderFns } from "./Support&Feedback.vue?vue&type=template&id=457a618d&"
import script from "./Support&Feedback.vue?vue&type=script&lang=js&"
export * from "./Support&Feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports